import { createTheme } from "@mui/material/styles";

import COLOR from "lib/colors";
import { PORTAL_NAV_BREAKPOINTS, STANDARD_BREAKPOINTS } from "lib/constants";

const appMuiTheme = createTheme({
    breakpoints: {
        values: {
            retainNavSm: PORTAL_NAV_BREAKPOINTS.sm,
            retainNavMd: PORTAL_NAV_BREAKPOINTS.md,
            retainNavLg: PORTAL_NAV_BREAKPOINTS.lg,

            // These are the default breakpoints, but we need to specify explicitly them because
            // we're providing other custom breakpoints above which would overwrite the defaults
            xs: STANDARD_BREAKPOINTS.xs,
            sm: STANDARD_BREAKPOINTS.sm,
            md: STANDARD_BREAKPOINTS.md,
            lg: STANDARD_BREAKPOINTS.lg,
            xl: STANDARD_BREAKPOINTS.xl,
        },
    },
    palette: {
        primary: {
            light: COLOR["indigo-light"],
            main: COLOR.indigo,
            dark: COLOR["indigo-dark"],
        },
        secondary: {
            light: COLOR["teal-light"],
            main: COLOR.teal,
            dark: COLOR["teal-dark"],
        },
    },
    typography: {
        fontFamily: "Inter, sans-serif",
    },
    components: {
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
                disableTouchRipple: true,
            },
        },
        MuiButton: {
            defaultProps: {
                disableElevation: true,
                disableFocusRipple: true,
                disableRipple: true,
            },
        },
        MuiDialog: {
            defaultProps: {
                maxWidth: "md",
            },
        },
        MuiIconButton: {
            defaultProps: {
                disableFocusRipple: true,
                disableRipple: true,
            },
        },
        MuiButtonGroup: {
            defaultProps: {
                disableElevation: true,
                disableFocusRipple: true,
                disableRipple: true,
            },
        },
        MuiTab: {
            defaultProps: {
                disableFocusRipple: true,
                disableRipple: true,
            },
        },
        MuiChip: {
            styleOverrides: {
                deleteIcon: ({ className }) => {
                    if (
                        !className.includes("MuiChip-pill") ||
                        !className.includes("MuiChip-colorPrimary")
                    ) {
                        return {};
                    }
                    return {
                        color: COLOR.indigo,
                        fontSize: 18,
                        "&:hover": {
                            color: COLOR["indigo-dark"],
                        },
                    };
                },
            },
            variants: [
                {
                    props: { variant: "pill" },
                    style: {
                        fontWeight: 500,
                        "&.MuiChip-colorPrimary": {
                            backgroundColor: COLOR["indigo-16"],
                            color: COLOR.indigo,
                        },
                    },
                },
            ],
        },
    },
});

export default appMuiTheme;
